<template>
  <div v-if="currentAd" class="">
    <div class="ads-banner__content">
      <img :src="currentAd.image" :alt="currentAd.title" class="ads-banner__image">
      <!-- <div class="ads-banner__badge">{{ $t('ads.sponsored') }}</div> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

interface Ad {
  title: string;
  image: string;
}

const ads: Ad[] = [
  {
    title: 'Demo',
    image: '/images/ads/PlopStyle.png'
  },
]

const currentAd = ref<Ad | null>(null)

onMounted(() => {
  // Pick a random ad
  const randomIndex = Math.floor(Math.random() * ads.length)
  currentAd.value = ads[randomIndex] || null
})
</script>


<style scoped>
.ads-banner {
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 2rem;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
  cursor: pointer;
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.ads-banner:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.2);
}

.ads-banner__content {
  margin-top: 70px;
  position: relative;
  aspect-ratio: 1200 / 300;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ads-banner__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ads-banner__badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@media (max-width: 768px) {
  .ads-banner__badge {
    font-size: 0.6rem;
    padding: 2px 6px;
  }
}
</style>
